var _circle, _path, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedTopic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1055,
    cy: 27,
    r: 18,
    fill: "#4E4D65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1061 23.6663H31.2728V21.9997C31.2728 19.6997 29.4061 17.833 27.1061 17.833C24.8061 17.833 22.9395 19.6997 22.9395 21.9997V23.6663H22.1061C21.1895 23.6663 20.4395 24.4163 20.4395 25.333V33.6663C20.4395 34.583 21.1895 35.333 22.1061 35.333H32.1061C33.0228 35.333 33.7728 34.583 33.7728 33.6663V25.333C33.7728 24.4163 33.0228 23.6663 32.1061 23.6663ZM27.1061 31.1663C26.1895 31.1663 25.4395 30.4163 25.4395 29.4997C25.4395 28.583 26.1895 27.833 27.1061 27.833C28.0228 27.833 28.7728 28.583 28.7728 29.4997C28.7728 30.4163 28.0228 31.1663 27.1061 31.1663ZM24.6061 23.6663V21.9997C24.6061 20.6163 25.7228 19.4997 27.1061 19.4997C28.4895 19.4997 29.6061 20.6163 29.6061 21.9997V23.6663H24.6061Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 25,
    stroke: "#4E4D65",
    strokeWidth: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedTopic);
export default __webpack_public_path__ + "static/media/lockedTopic.b5a872d664e2e67fbb2f696dc0092d2c.svg";
export { ForwardRef as ReactComponent };